module.exports = __webpack_public_path__ + "img/dg1.3a3d90a7.jpg";